import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { updateAdminRole } from 'src/features/administrators/tenant/api/lib/admins';
import { adminsKeys } from 'src/features/administrators/tenant/api/query-keys/admins';
import { UserRole } from 'src/types/enum/user-role';
import { ApiError } from 'src/types/interfaces/api-error';
import { delayedCallbackExecution } from 'src/utils/delayed-callback-execution';

export const useUpdateAdminRole = (onSuccess?: () => void) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ token, role }: { token: string; role: UserRole }) =>
      updateAdminRole(token, role),
    onSuccess: () => {
      delayedCallbackExecution(1000, () => {
        queryClient.invalidateQueries({ queryKey: adminsKeys.all });
      });
      onSuccess?.();
      toast.success(t('organizationDetails:admins.toast.success.update'));
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message);
    },
  });
};
